import React, { useEffect, useState } from "react";
import "./Navbar.css";
import { Link, useRoutes } from "react-router-dom";
import logo from "../images/logo.png";
import { blogListPageURL, contactusPageURL, loanPageURL, testimonialsSectionURL } from "../../constants/path_constants";
import Modal from "../Modal/Modal";

const Navbar = () => {
  const [width, setWidth] = useState(window.innerWidth);

const [isShowModal, setIsShowModal] = useState(false)


useEffect(() => {
  const handleResize = () => {
    setWidth(window.innerWidth);
  };
  window.addEventListener("resize", handleResize);
  return () => {
    window.removeEventListener("resize", handleResize);
  };
}, []);
const closemenu = () => {
  setIsShowModal(false)
}

const openmenu = () => {
  setIsShowModal(true)
}

const handleLinkClick = () => {
  closemenu();
};
  
  return (
    <nav className="navbar-one">
      <div style={{display:'flex',flexDirection:'row',justifyContent:'space-between',width:'100%',padding:'0px 30px 0px 30px'}}>
      <Link to="./">
        <img className="wedding-logo" src={logo} />
      </Link>
      {
    width < 768 &&
      <div onClick={()=> openmenu()}>
      <img src="https://vmnk.gumlet.io/menu.png" alt="menu" style={{width:'30px',height:'30px'}}/>

      </div> }
      </div>


<Modal
      open={
              isShowModal
              }
              onClose={closemenu}
              width={'100%'}
              height={"auto"}
              position={"right"}
              style={{top:0,backgroundColor:'#e86885'}}>
                {/* <div style={{height:'1px',width:'auto',backgroundColor:'white',marginTop:"30px",marginLeft:'-30px'}} /> */}
   <div style={{marginBottom:'50px'}} >
        <li className="navbar-link-text">
          <Link to={blogListPageURL} className="nav-link" onClick={handleLinkClick}>
            Blog
          </Link>
        </li>
        <li className="navbar-link-text">
          <Link to={loanPageURL} className="nav-link" onClick={handleLinkClick}>
            Loan
          </Link>
        </li>

        <li className="navbar-link-text">
          <Link to={testimonialsSectionURL} className="nav-link " onClick={handleLinkClick}>
            Testimonials
          </Link>
        </li>

        <li className="navbar-link-text">
          <Link to={contactusPageURL} className="nav-link " onClick={handleLinkClick}>
            Contact
          </Link>
        </li>

      </div>
              </Modal>

   {
    width > 768 &&
    <ul className="nav-list">
    <li>
      <Link to={blogListPageURL} className="nav-link">
        Blog
      </Link>
    </li>
    <li>
      <Link to={loanPageURL} className="nav-link">
        Loan
      </Link>
    </li>
    <li>
      <Link to={testimonialsSectionURL} className="nav-link ">
        Testimonials
      </Link>
    </li>
    <li>
      <Link to={contactusPageURL} className="nav-link ">
        Contact
      </Link>
    </li>
  </ul>
   }
    </nav>
  );
};

export default Navbar;
